(() => {
  const clean = value => String(value || '').replace(/❤️/g, '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const key = value => clean(value).toLowerCase();
  const srcKey = url => {
    try { return new URL(url, location.href).pathname.toLowerCase(); }
    catch (_) { return String(url || '').split('?')[0].toLowerCase(); }
  };
  const isLegacyFixedTest = value => /^(200|500)\s*hz\b/i.test(clean(value));

  const recoveredLinks = new Map([
    ['cha cha slide', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/906e7f98c438c683d231ae0861c7e6ae.mp3?v=1647499311'],
    ['toy war', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/toy_war.mp3?v=1647499311'],
    ['a thousand cherry blossoms', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/0219941e350ac671194c0932303ffc7d_a9c92ba9-48f6-4d6d-8f0f-71d9415d2097.mp3?v=1647499312'],
    ['canon variations +', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/a479e192fa0a5de1bfb6e679a3b4f526.mp3?v=1647499311'],
    ['little apple c', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/2.mp3?v=1647499311'],
    ['twinkle twinkle little star', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/06216eff46b3476fa1d392e72b63b0fe.mp3?v=1647499312'],
    ['popkart bgm store', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/bgm_9279ad63-4f88-456f-ac6a-751977fd23e3.mp3?v=1647499312'],
    ['the light of humanity', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/eb2b242fff26b917b561bef2d07f49fe.mp3?v=1647499311'],
    ['玩具大战', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/toy_war.mp3?v=1647499311'],
    ['千本樱 - 初音ミク', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/0219941e350ac671194c0932303ffc7d_a9c92ba9-48f6-4d6d-8f0f-71d9415d2097.mp3?v=1647499312'],
    ['卡农变奏+', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/a479e192fa0a5de1bfb6e679a3b4f526.mp3?v=1647499311'],
    ['小苹果c', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/2.mp3?v=1647499311'],
    ['星星点灯', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/06216eff46b3476fa1d392e72b63b0fe.mp3?v=1647499312'],
    ['跑跑卡丁车bgm商店', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/bgm_9279ad63-4f88-456f-ac6a-751977fd23e3.mp3?v=1647499312'],
    ['人类的光', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/eb2b242fff26b917b561bef2d07f49fe.mp3?v=1647499311'],
    ['甩葱歌', 'https://cdn.shopify.com/s/files/1/0584/2570/4622/files/906e7f98c438c683d231ae0861c7e6ae.mp3?v=1647499311']
  ]);

  const titleCorrections = new Map([
    ['cha cha slide', 'Leekspin'],
    ['cha cha slide mix', 'Leekspin Mix'],
    ['a thousand cherry blossoms', 'Senbonzakura (千本桜)'],
    ['twinkle twinkle little star', 'Xing Xing Dian Deng (星星点灯)']
  ]);

  /* Titles for English-master tracks that never existed in the older Chinese Page. */
  const zhMissingTitles = new Map([
    ['jingle bell1', '铃儿响叮当 1'],
    ['jingle bell2', '铃儿响叮当 2'],
    ['we wish you a merry christmas', '祝你圣诞快乐'],
    ['nyan cat', '彩虹猫（Nyan Cat）'],
    ['bad apple', '坏苹果（Bad Apple）'],
    ['plants vs zombies loading', '植物大战僵尸：加载音乐'],
    ['to the moon everything alright', '去月球：Everything’s Alright'],
    ['korobeiniki', '俄罗斯方块主题曲（Korobeiniki）'],
    ['spirited away: always with me', '千与千寻：永远同在'],
    ["spirited away: one summer's day", '千与千寻：那个夏天'],
    ['the flower we saw that day', '未闻花名'],
    ['my heart will go on', '我心永恒'],
    ['imperial march', '帝国进行曲'],
    ['gimme gimme gimme', '给我！给我！给我！（Gimme! Gimme! Gimme!）'],
    ['mamma mia', '妈妈咪呀'],
    ['super trouper', '超级聚光灯（Super Trouper）'],
    ['summer', '夏日（Summer）'],
    ['auld lang syne', '友谊地久天长'],
    ['rice fragrance', '稻香（新版）'],
    ['love song 1990', '恋曲1990'],
    ['a spray of plum blossoms', '一剪梅'],
    ['sweet little happiness', '小幸运']
  ]);

  function prepareSource(source) {
    if (!source || source.dataset.triggerSourceReady === '1') return;
    source.dataset.triggerSourceReady = '1';

    [...source.querySelectorAll('a[href]')].forEach(anchor => {
      if (!/\.mp3(?:$|\?)/i.test(anchor.href)) return;
      const oldKey = key(anchor.textContent);
      if (recoveredLinks.has(oldKey)) anchor.href = recoveredLinks.get(oldKey);
      if (titleCorrections.has(oldKey)) {
        const recommended = String(anchor.textContent || '').includes('❤️');
        anchor.textContent = `${recommended ? '❤️' : ''}${titleCorrections.get(oldKey)}`;
      }
    });

    [...source.querySelectorAll('a[href]')].forEach(anchor => {
      if (!/\.mp3(?:$|\?)/i.test(anchor.href) || !isLegacyFixedTest(anchor.textContent)) return;
      const block = anchor.closest('p,li');
      if (block) {
        const mp3Links = [...block.querySelectorAll('a[href]')].filter(link => /\.mp3(?:$|\?)/i.test(link.href));
        if (mp3Links.length && mp3Links.every(link => isLegacyFixedTest(link.textContent))) {
          block.remove();
          return;
        }
      }
      anchor.remove();
    });
  }

  function parseTrackBlocks(source) {
    const result = [];
    if (!source) return result;
    [...source.children].forEach(node => {
      const links = [...node.querySelectorAll('a[href]')]
        .filter(anchor => /\.mp3(?:$|\?)/i.test(anchor.href) && clean(anchor.textContent));
      if (!links.length) return;
      const anchor = links[links.length - 1];
      const rawTitle = links.length > 1 ? clean(node.textContent) : clean(anchor.textContent);
      if (!rawTitle) return;
      result.push({
        title: rawTitle,
        src: anchor.href,
        recommended: String(node.textContent || '').includes('❤️')
      });
    });
    return result;
  }

  function synchronizeChineseLibrary(root) {
    if (root.dataset.smLang !== 'zh') return;
    const chineseSource = root.querySelector('[data-sm-source]');
    const englishSource = root.querySelector('[data-sm-reference-source]');
    if (!chineseSource || !englishSource) return;

    /* Preserve every existing Chinese name by canonical MP3 URL. */
    const chineseBySource = new Map();
    [...chineseSource.querySelectorAll('a[href]')].forEach(anchor => {
      if (!/\.mp3(?:$|\?)/i.test(anchor.href)) return;
      const title = clean(anchor.textContent);
      if (title) chineseBySource.set(srcKey(anchor.href), title);
    });

    /* The English Page is the master list. After the trigger/link corrections it is the same
       canonical 124-track set shown by the English tool. */
    const masterTracks = parseTrackBlocks(englishSource);
    const fragment = document.createDocumentFragment();

    masterTracks.forEach(track => {
      const englishKey = key(track.title);
      let chineseTitle = chineseBySource.get(srcKey(track.src));
      if (zhMissingTitles.has(englishKey)) chineseTitle = zhMissingTitles.get(englishKey);
      if (!chineseTitle) chineseTitle = track.title;

      const p = document.createElement('p');
      const a = document.createElement('a');
      a.href = track.src;
      a.textContent = `${track.recommended ? '❤️' : ''}${chineseTitle}`;
      p.appendChild(a);
      fragment.appendChild(p);
    });

    chineseSource.replaceChildren(fragment);
    chineseSource.dataset.syncedToEnglishMaster = String(masterTracks.length);
  }

  function enforceFullOutput(root) {
    const audio = root.querySelector('[data-sm-audio]');
    const hiddenVolume = root.querySelector('[data-sm-volume]');
    if (hiddenVolume) {
      hiddenVolume.value = '1';
      hiddenVolume.disabled = true;
      hiddenVolume.setAttribute('aria-hidden', 'true');
    }
    if (audio && audio.volume !== 1) audio.volume = 1;
    try { localStorage.setItem('warden-square-volume', '1'); } catch (_) {}
  }

  function prepare(root) {
    if (!root || root.dataset.triggerPolicyReady === '1') return;
    root.dataset.triggerPolicyReady = '1';
    root.querySelectorAll('[data-sm-source], [data-sm-reference-source]').forEach(prepareSource);
    synchronizeChineseLibrary(root);
    enforceFullOutput(root);

    root.addEventListener('pointerdown', () => enforceFullOutput(root), true);
    root.addEventListener('click', () => enforceFullOutput(root), true);
    const audio = root.querySelector('[data-sm-audio]');
    if (audio) {
      audio.addEventListener('play', () => enforceFullOutput(root), true);
      audio.addEventListener('volumechange', () => {
        if (audio.volume !== 1) audio.volume = 1;
      }, true);
    }
  }

  const initAll = (scope = document) => scope.querySelectorAll('[data-square-music-tool]').forEach(prepare);
  initAll();
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
